import LocationsFixture from '../static-data/LocationsFixture'

const useLocation = () => {
  return LocationsFixture
}
export default useLocation
